(function(){
  'use strict';

  function init(){
    var shells=[].slice.call(document.querySelectorAll('[data-klx-video-shell]'));
    var passiveVideos=[].slice.call(document.querySelectorAll('[data-klx-passive-video]'));
    if(!shells.length && !passiveVideos.length)return;

    var state={soundEnabled:false,active:null,interactionArmed:true,needsGestureAudio:false};
    var manuallyPaused=new WeakSet();
    try{state.soundEnabled=localStorage.getItem('klxVideoSound')==='on';}catch(e){}

    function videoOf(shell){return shell&&shell.querySelector('[data-klx-audio-video]');}
    function playBtn(shell){return shell&&shell.querySelector('[data-klx-play-toggle]');}
    function soundBtn(shell){return shell&&shell.querySelector('[data-klx-sound-toggle]');}
    function isHero(shell){return shell&&shell.getAttribute('data-klx-video-section')==='hero';}
    function wantsAutoSound(shell){return shell&&shell.getAttribute('data-klx-autosound')==='true';}
    function isMobile(){return window.matchMedia&&window.matchMedia('(max-width: 720px)').matches;}

    function sync(shell){
      var video=videoOf(shell),p=playBtn(shell),s=soundBtn(shell);
      if(!video)return;
      if(p){
        var playing=!video.paused&&!video.ended;
        p.setAttribute('aria-pressed',playing?'true':'false');
        p.setAttribute('aria-label',playing?'Pause video':'Play video');
        var pl=p.querySelector('span'); if(pl)pl.textContent=playing?'Pause':'Play';
      }
      if(s){
        var on=!video.muted;
        s.setAttribute('aria-pressed',on?'true':'false');
        s.setAttribute('aria-label',on?'Turn video sound off':'Turn video sound on');
        var sl=s.querySelector('span'); if(sl)sl.textContent=on?'Sound off':'Sound on';
      }
    }

    function pauseShell(shell,temporary){
      var video=videoOf(shell); if(!video)return;
      if(!video.paused)video.pause();
      if(temporary){
        video.muted=true;
        video.defaultMuted=true;
      }
      if(state.active===shell)state.active=null;
      sync(shell);
    }

    function pauseAll(except){
      shells.forEach(function(shell){
        if(shell===except)return;
        pauseShell(shell,true);
      });
      passiveVideos.forEach(function(video){
        if(!video.paused)video.pause();
      });
    }

    function playWithPreference(shell,fromViewport){
      var video=videoOf(shell); if(!video)return Promise.resolve();
      if(fromViewport&&manuallyPaused.has(shell))return Promise.resolve();

      state.active=shell;
      pauseAll(shell);

      var wantsSound=state.soundEnabled && !fromViewport;
      video.muted=!wantsSound;
      video.defaultMuted=!wantsSound;

      var pr;
      try{pr=video.play();}catch(e){pr=null;}
      if(pr&&pr.then){
        return pr.then(function(){
          if(wantsSound&&!video.muted){
            state.soundEnabled=true;
            state.needsGestureAudio=false;
            try{localStorage.setItem('klxVideoSound','on');}catch(e){}
          }
        }).catch(function(){
          video.muted=true;
          video.defaultMuted=true;
          if(wantsAutoSound(shell))state.needsGestureAudio=true;
          return video.play().catch(function(){});
        }).finally(function(){sync(shell);});
      }

      if(wantsSound&&!video.muted){
        state.soundEnabled=true;
        state.needsGestureAudio=false;
        try{localStorage.setItem('klxVideoSound','on');}catch(e){}
      }
      sync(shell);
      return Promise.resolve();
    }

    shells.forEach(function(shell){
      if(shell.dataset.klxVideoControlsReady==='true')return;
      shell.dataset.klxVideoControlsReady='true';

      var video=videoOf(shell),p=playBtn(shell),s=soundBtn(shell);
      if(!video)return;

      if(!isHero(shell)){
        video.muted=true;
        video.defaultMuted=true;
        if(!video.paused)video.pause();
      }

      p&&p.addEventListener('click',function(){
        if(video.paused){
          manuallyPaused.delete(shell);
          playWithPreference(shell,false);
        }else{
          manuallyPaused.add(shell);
          video.pause();
          if(state.active===shell)state.active=null;
          sync(shell);
        }
      });

      s&&s.addEventListener('click',function(){
        manuallyPaused.delete(shell);
        if(video.muted){
          state.soundEnabled=true;
          try{localStorage.setItem('klxVideoSound','on');}catch(e){}
          video.muted=false;
          video.defaultMuted=false;
          state.active=shell;
          pauseAll(shell);
          try{
            var p1=video.play();
            if(p1&&p1.catch)p1.catch(function(){});
          }catch(e){}
        }else{
          state.soundEnabled=false;
          try{localStorage.setItem('klxVideoSound','off');}catch(e){}
          video.muted=true;
          video.defaultMuted=true;
        }
        sync(shell);
      });

      video.addEventListener('play',function(){sync(shell);});
      video.addEventListener('pause',function(){sync(shell);});
      sync(shell);
    });

    var hero=shells.find(isHero);
    if(hero){
      var hv=videoOf(hero);
      if(hv){
        // Start silently so autoplay works reliably in Chrome, Safari and mobile.
        // Audio starts only after the shopper taps the dedicated Sound control.
        hv.muted=true;
        hv.defaultMuted=true;
        state.active=hero;
        if(!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
          try{
            var hp=hv.play();
            if(hp&&hp.catch)hp.catch(function(){sync(hero);});
          }catch(e){}
        }else{
          // Respect the visitor's reduced-motion preference even when
          // the HTML autoplay attribute starts playback before JS initializes.
          hv.pause();
          manuallyPaused.add(hero);
        }
        sync(hero);
      }
    }

    if('IntersectionObserver' in window&&shells.length){
      var ratios=new Map();
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){ratios.set(entry.target,entry.intersectionRatio);});

        var activateAt=isMobile()?0.48:0.42;
        var pauseAt=isMobile()?0.20:0.18;
        var best=null,bestRatio=0;

        shells.forEach(function(shell){
          var r=ratios.get(shell)||0;
          if(r>bestRatio){best=shell;bestRatio=r;}
        });

        shells.forEach(function(shell){
          var r=ratios.get(shell)||0;
          if(shell===best&&r>=activateAt){
            if((state.active!==shell||videoOf(shell).paused)&&!manuallyPaused.has(shell)){
              playWithPreference(shell,true);
            }
          }else if(r<pauseAt){
            pauseShell(shell,true);
          }
        });
      },{threshold:[0,.1,.18,.20,.35,.42,.48,.7,.85]});
      shells.forEach(function(shell){io.observe(shell);});
    }

    if('IntersectionObserver' in window&&passiveVideos.length){
      var pio=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var video=entry.target;
          video.muted=true;
          video.defaultMuted=true;
          if(entry.isIntersecting&&entry.intersectionRatio>=0.38&&!document.hidden){
            try{
              var pr=video.play();
              if(pr&&pr.catch)pr.catch(function(){});
            }catch(e){}
          }else{
            if(!video.paused)video.pause();
          }
        });
      },{threshold:[0,.15,.38,.6]});
      passiveVideos.forEach(function(video){pio.observe(video);});
    }

    document.addEventListener('visibilitychange',function(){
      if(document.hidden){
        shells.forEach(function(shell){pauseShell(shell,true);});
        passiveVideos.forEach(function(video){if(!video.paused)video.pause();});
      }else if(!document.hidden){
        // Resume only the visibly displayed film; never override a manual pause.
        var best=null,bestRatio=0;
        shells.forEach(function(shell){
          var box=shell.getBoundingClientRect(),vh=window.innerHeight||1;
          var visible=Math.max(0,Math.min(box.bottom,vh)-Math.max(box.top,0));
          var ratio=visible/Math.max(1,box.height);
          if(ratio>bestRatio){best=shell;bestRatio=ratio;}
        });
        if(best&&bestRatio>=(isMobile()?0.48:0.42)&&!manuallyPaused.has(best)){
          playWithPreference(best,true);
        }
      }
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();